/**
 * Módulo Vuex para estado de sincronización y conectividad
 */
export const offlineSync = {
    namespaced: true,
    state: {
        isOnline: navigator.onLine,
        pendingCount: 0,
        isSyncing: false,
        lastSyncTimestamp: null,
    },
    getters: {
        isOnline: (state) => state.isOnline,
        pendingCount: (state) => state.pendingCount,
        isSyncing: (state) => state.isSyncing,
        lastSyncTimestamp: (state) => state.lastSyncTimestamp,
    },
    mutations: {
        setOnline(state, status) {
            state.isOnline = status;
        },
        setPendingCount(state, count) {
            state.pendingCount = count;
        },
        setSyncing(state, status) {
            state.isSyncing = status;
            if (!status) {
                state.lastSyncTimestamp = new Date().toISOString();
            }
        },
    },
    actions: {
        updatePendingCount({ commit }, count) {
            commit('setPendingCount', count);
        },
    }
};
